<template>
  <div :class="['color-select-option', {
    'color-select-option_selected' : isSelected,
  }]"
  >
    <div :class="['color-select-option__inner', {
      'color-select-option__inner_border' : hasBorder,
    }]" :style="background"
    />
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    background() {
      return `background-color: ${this.color}`;
    },
    hasBorder() {
      return this.color.toLocaleLowerCase() === '#ffffff';
    }
  }
}
</script>

<style lang="scss">
  .color-select-option {
    width: 24px;
    height: 24px;
    padding: 3px;
    border-radius: 100%;
    border: 1px solid transparent;
    transition: $transitionDuration border-color ease;

    &_selected {
      border-color: $black;
    }

    &__inner {
      border-radius: 100%;
      height: 100%;

      &_border {
        border: 1px solid $gray_lu;
      }
    }
  }
</style>
